<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <settingsMenu></settingsMenu>
        <div class="widget-heading">
        </div>
        <div class="widget-content">
          <div class="table-responsive">
          <table class="table table-bordered table-hover">
            <tbody>
            <tr>
              <td>Rodzaj wydruku PDF zestawienia listy urlopów</td>
              <td>
                <select id="lokalnySelPDF" v-model="lokalnySelPDF" @change="changePDF()" class="form-select"
                        style="border-radius: 0;">
                  <option value="0">Poziomy</option>
                  <option value="1">Pionowy</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>Ile miesięcy wcześniej powiadamiać o niewykorzystanym urlopie 14 dni</td>
              <td>
                <input id="lokalnyMiesiaceUrlopy" v-model="lokalnyMiesiaceUrlopy" class="form-control"
                       style="border-radius: 0;" type="number" @change="updateSettings(2, lokalnyMiesiaceUrlopy)"/>
              </td>
            </tr>
            </tbody>
          </table>
          </div>
        </div>

        <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-inline-flex align-items-center">
              <label>Adresy e-mail, na które będą wysyłane zatwierdzone wnioski o urlop/przepustkę</label>
              <button @click="addEmail" class="btn btn-primary btn-sm ms-5">
                <i class="bi bi-plus-circle me-2"></i>Dodaj adres e-mail
              </button>
            </div>
          </div>
        </div>
        <div class="widget-content">
          <div class="table-responsive">
            <table class="table table-hover table-bordered">
              <thead>
              <tr>
                <th>#</th>
                <th>Adres e-mail</th>
                <th>Akcje</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(email, index) in adresy_email" :key="index">
                <td>{{ index + 1 }}</td>
                <td>
                  <input v-if="editingId === email.id" v-model="email.nazwa" class="form-control"/>
                  <span v-else>{{ email.nazwa }}</span>
                </td>
                <td>
                  <button v-if="editingId === email.id" @click="updateEmail(email)" class="btn btn-sm btn-success me-2">
                    Zapisz
                  </button>
                  <button v-else @click="editEmail(email.id)" class="btn btn-sm btn-outline-info me-2"><i
                      class="bi bi-pencil me-2"></i>Edytuj
                  </button>
                  <button @click="deleteEmail(email.id)" class="btn btn-sm btn-danger"><i class="bi bi-trash me-2"></i>Usuń
                  </button>
                </td>
              </tr>
              <tr v-if="addingNew">
                <td>Nowy</td>
                <td><input v-model="newEmail.nazwa" class="form-control"/></td>
                <td>
                  <button @click="saveNewEmail" class="btn btn-sm btn-success me-1"><i class="bi bi-save me-2"></i>Zapisz
                  </button>
                  <button @click="cancelNewEmail" class="btn btn-sm btn-danger"><i class="bi bi-x-circle me-2"></i>Anuluj
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-inline-flex align-items-center">
              <label>Adresy e-mail, na które będą wysyłane wnioski kierowników do zatwierdzenia o
                urlop/przepustkę</label>
              <button @click="addEmail2" class="btn btn-primary btn-sm ms-5">
                <i class="bi bi-plus-circle me-2"></i>Dodaj adres e-mail
              </button>
            </div>
          </div>
        </div>
        <div class="widget-content">
          <div class="table-responsive">
            <table class="table table-hover table-bordered">
              <thead>
              <tr>
                <th>#</th>
                <th>Adres e-mail</th>
                <th>Akcje</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(email2, index) in adresy_email2" :key="index">
                <td>{{ index + 1 }}</td>
                <td>
                  <input v-if="editingId2 === email2.id" v-model="email2.nazwa" class="form-control"/>
                  <span v-else>{{ email2.nazwa }}</span>
                </td>
                <td>
                  <button v-if="editingId2 === email2.id" @click="updateEmail2(email2)"
                          class="btn btn-sm btn-success me-2">Zapisz
                  </button>
                  <button v-else @click="editEmail2(email2.id)" class="btn btn-sm btn-outline-info me-2"><i
                      class="bi bi-pencil me-2"></i>Edytuj
                  </button>
                  <button @click="deleteEmail2(email2.id)" class="btn btn-sm btn-danger"><i
                      class="bi bi-trash me-2"></i>Usuń
                  </button>
                </td>
              </tr>
              <tr v-if="addingNew2">
                <td>Nowy</td>
                <td><input v-model="newEmail2.nazwa" class="form-control"/></td>
                <td>
                  <button @click="saveNewEmail2" class="btn btn-sm btn-success me-1"><i class="bi bi-save me-2"></i>Zapisz
                  </button>
                  <button @click="cancelNewEmail2" class="btn btn-sm btn-danger"><i class="bi bi-x-circle me-2"></i>Anuluj
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>


      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";
import settingsMenu from "@/Pages/Kadry/parts/settingsMenu.vue";

const {hasPermission} = usePermission();

export default {
  components: {AppLayout, settingsMenu},
  props: {
    SelPDF: Number,
    miesiaceUrlopy: Number,
    adresy_email: Array,
    adresy_email2: Array
  },
  data() {
    return {
      hasPermission,
      editingId: null,
      addingNew: false,
      newEmail: this.getEmptyForm(),
      editingId2: null,
      addingNew2: false,
      newEmail2: this.getEmptyForm(),
      lokalnySelPDF: this.SelPDF,
      lokalnyMiesiaceUrlopy: this.miesiaceUrlopy
    };
  },
  methods: {
    getEmptyForm() {
      return {
        id: null,
        name: ''
      };
    },
    addEmail() {
      this.addingNew = true;
      this.newEmail = this.getEmptyForm();
    },
    cancelNewEmail() {
      this.addingNew = false;
      this.newEmail = this.getEmptyForm();
    },
    editEmail(id) {
      this.editingId = id;
    },

    updateEmail(email) {
      this.$inertia.put(route('kadry.urlopy.email.update', email.id), {
        ...email,
        typ: 1,
      }, {
        onSuccess: () => {
          this.editingId = null;
        }
      });
    },

    saveNewEmail() {
      this.$inertia.post(route('kadry.urlopy.email.dodaj'), {
        ...this.newEmail,
        typ: 1,
      }, {
        onSuccess: () => {
          this.addingNew = false;
          this.newEmail = this.getEmptyForm();
        }
      });
    },
    deleteEmail(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie adresu e-mail',
        html: 'Czy na pewno chcesz usunąć wybrany adres e-mail?',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
        timer: false,
        position: 'center'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(route('kadry.urlopy.email.usun', id));
        }
      });
    },

    addEmail2() {
      this.addingNew2 = true;
      this.newEmail2 = this.getEmptyForm();
    },
    cancelNewEmail2() {
      this.addingNew2 = false;
      this.newEmail2 = this.getEmptyForm();
    },
    editEmail2(id) {
      this.editingId2 = id;
    },

    updateEmail2(email) {
      this.$inertia.put(route('kadry.urlopy.email.update', email.id), {
        ...email,
        typ: 2,
      }, {
        onSuccess: () => {
          this.editingId2 = null;
        }
      });
    },

    saveNewEmail2() {
      this.$inertia.post(route('kadry.urlopy.email.dodaj'), {
        ...this.newEmail2,
        typ: 2,
      }, {
        onSuccess: () => {
          this.addingNew2 = false;
          this.newEmail2 = this.getEmptyForm();
        }
      });
    },

    deleteEmail2(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie adresu e-mail',
        html: 'Czy na pewno chcesz usunąć wybrany adres e-mail?',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
        timer: false,
        position: 'center'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(route('kadry.urlopy.email.usun', id));
        }
      });
    },

    async changePDF() {
      try {
        await axios.put(route('kadry.change.pdf'), {
          SelPDF: this.lokalnySelPDF,
          SelID: 1,
        });
        this.showToast('success', 'Zapisano', 'Ustawienia zostały zaktualizowane.');
      } catch (err) {
        console.error(err);
        this.showToast('error', 'Błąd', 'Nie udało się zapisać danych.');
      }
    },

    async updateSettings(id, wartosc) {
      try {
        await axios.put(route('kadry.settings.update'), {
          id: id,
          val: wartosc,
        });
        this.showToast('success', 'Zapisano', 'Ustawienia zostały zaktualizowane.');
      } catch (err) {
        console.error(err);
        this.showToast('error', 'Błąd', 'Nie udało się zapisać danych.');
      }
    },

    showToast(icon, title, message) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: icon,
        title: title,
        html: message,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }


  }
};
</script>
